<template>
  <div
    class="ce-toast-content"
    :class="type.key"
    :data-e2e="ToastViewCypressAttribute.views.TOAST"
  >
    <i
      v-if="hasIcon"
      class="ce-toast-icon"
      :class="stateIconClass"
      :data-e2e="ToastViewCypressAttribute.views.ICON"
      aria-hidden="true"
    ></i>
    <div
      class="ce-toast-text"
      :data-e2e="ToastViewCypressAttribute.views.TEXT"
      v-dompurify-html="message"
    ></div>
    <div
      v-if="hasActions"
      class="ce-toast-actions"
      :data-e2e="ToastViewCypressAttribute.views.ACTIONS"
    >
      <button
        v-if="actionText"
        type="button"
        class="ce-toast-action"
        :data-e2e="ToastViewCypressAttribute.buttons.ACTION"
        @click="$emit('action')"
      >
        {{ actionText }}
      </button>
      <button
        v-if="hasCloseButton"
        type="button"
        class="ce-toast-close"
        :data-e2e="ToastViewCypressAttribute.buttons.CLOSE"
        :aria-label="closeLabel"
        @click="$emit('close')"
      >
        <i :class="closeIconClass" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { Icon } from '@/modules/core/app/enums/Icon';
import { ToastViewCypressAttribute } from '@/modules/core/ui/constants/ToastViewCypressAttribute';
import { ToastType } from '@/modules/core/ui/enums/ToastType';

export default defineComponent({
  name: 'ToastView',
  emits: ['close', 'action'],
  props: {
    type: {
      type: Object as PropType<ToastType>,
      required: true
    },
    message: {
      type: String as PropType<string>,
      required: true
    },
    hasIcon: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    hasCloseButton: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    actionText: {
      type: String as PropType<string>,
      default: ''
    }
  },
  static: {
    ToastViewCypressAttribute
  },
  computed: {
    stateIconClass(): string {
      return `cls cls-${this.type.icon}`;
    },
    closeIconClass(): string {
      return `cls cls-${Icon.REMOVE}`;
    },
    hasActions(): boolean {
      return !!this.actionText || this.hasCloseButton;
    },
    closeLabel(): string {
      return this.$t('core.close-notification');
    }
  }
});
</script>
